import Styles from './UserQuizzes.module.scss';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

// Module imports
import FeatherIcon from 'feather-icons-react';
import axios from 'axios';

// Component imports.
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import QuizViewCard from 'components/global/QuizViewCard/QuizViewCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { useAPI, ViewContext, AuthContext, Message } from 'components/lib';

export function UserQuizzes(props) {

    const authContext = useContext(AuthContext);
    const viewContext = useContext(ViewContext);
    const navigate = useNavigate();

    const { data, loading } = useAPI('/api/qq/user');

    const enrollToQQ = () => {
        const options = {
            method: "POST",
            url: `/api/qq/enroll`,
            headers: {
                "accept": "application/json",
            },
            data: {},
        };
        axios
            .request(options)
            .then(function (response) {
                if (response.status === 201) {
                    viewContext.notification.show(props.t('QualityQuotient.UserQuizzes.notification'), 'success');
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500);
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show(err.message, 'error');
            });
    }

    return (
        <>
            <Message
                closable
                title={props.t('QualityQuotient.UserQuizzes.message.title')}
                text={props.t('QualityQuotient.UserQuizzes.message.descr')}
                type="info"
            />
            <LoadingBackdrop isOpen={loading} />
            <div id='ancestorContainer' className={Styles.ancestorContainer}>
                <span id='headerSpan' className={Styles.headerSpan}>
                    <BreadCrumbs
                        onClickPaths={[
                            ''
                        ]}
                        crumbs={[
                            props.t('QualityQuotient.UserQuizzes.breadCrumbs')
                        ]}
                    />
                    {data?.quizzes?.length !== 0 &&
                        <AivagamButton
                            buttonText={props.t('QualityQuotient.UserQuizzes.button.text')}
                            onClick={() => navigate(`/qq/report`)}
                            disabled={!data?.hasUserFinished}
                            tooltipText={props.t('QualityQuotient.UserQuizzes.button.tooltip')}
                        />
                    }
                </span>
                {data?.quizzes?.length === 0 ?
                    (
                        <div id='enrollContainer' className={Styles.enrollContainer}>
                            <p>
                                {props.t('QualityQuotient.UserQuizzes.info')} </p>
                            <AivagamButton
                                buttonText={
                                    <>
                                        <FeatherIcon
                                            color='black'
                                            icon='plus-circle'
                                        />
                                        {props.t('QualityQuotient.UserQuizzes.button.enroll')} </>
                                }
                                onClick={enrollToQQ}
                                type='action'
                                icon
                            />
                        </div>
                    ) : (
                        <div id='quizzesContainer' className={Styles.quizzesContainer}>
                            {
                                data?.quizzes?.map((quiz, index) =>
                                    <QuizViewCard
                                        data={quiz}
                                        key={quiz.qq_id}
                                        onStartClick={() => { navigate(`/qq/${quiz.qq_id}/attempt`) }}
                                        button_text={quiz.button_text}
                                    />
                                )
                            }
                        </div>
                    )
                }
            </div>
        </>
    );
}